import { useEffect, useState } from "react";
import FilterWrapper from "utils/FilterWrapper/FilterWrapper";
import ExportAndFilter from "components/Reuseables/ExportAndFilter/ExportAndFilter";
import { merchantsReportHeadings } from "../data";
import CustomInputBox from "utils/inputBox/CustomInputBox/CustomInputBox";

const MerchantsFilter = ({ data, filters, handleFilters, clearFilters }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [formValues, setFormValues] = useState({ keyword: "" });
  const [isApplied, setIsApplied] = useState(false);

  useEffect(() => {
    if (filters) {
      setFormValues(filters);
      setIsApplied(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const clearFilter = () => {
    setFormValues({ keyword: "" });
    clearFilters();
    setIsApplied(false);
  };

  const handleSelect = (name, value) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleChange = ({ target: { name, value } }) => {
    handleSelect(name, value);
  };

  const handleSubmit = () => {
    handleFilters({ ...formValues });
    setIsApplied(true);
  };

  return (
    <div className="filters__container">
      <ExportAndFilter
        data={{
          data,
          filters,
          tableHeadings: merchantsReportHeadings,
          subTitle: "Download Merchants  Report",
        }}
        handleFilters={handleFilters}
        clearFilters={clearFilters}
        hideExportBtn={data?.total === 0}
        onClick={() => setIsOpen((prev) => !prev)}
      />
      {isOpen && (
        <FilterWrapper
          handleFilter={handleSubmit}
          clearFilter={clearFilter}
          isApplied={isApplied}
          isFilter
        >
          <CustomInputBox
            label="Search"
            placeholder="Keyword"
            name="keyword"
            onChange={handleChange}
            value={formValues?.keyword}
          />
        </FilterWrapper>
      )}
    </div>
  );
};

export default MerchantsFilter;
